// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__mVvOv","currentPage":"Pagination_currentPage__qMz3A","prevPage":"Pagination_prevPage__H2HpJ","nextPage":"Pagination_nextPage__jobNs"};